import { BankAccount, ADIInvoicePaymentResponseModel, payInvoice } from "@NA/Services/ADIInvoiceService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnError, HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<BankAccount & HasOnSuccess & HasOnError, ADIInvoicePaymentResponseModel>;

export const DispatchBeginLoadPayInvoice: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadPayInvoice",
        parameter:props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await payInvoice(props.apiParameter);
};

export const CompleteLoadPayInvoice: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
        props.dispatch({
            type: "Custom/CompleteLoadPayInvoice",
            payInvoiceResult: props.apiResult
        });
    }
};

export const chain = [DispatchBeginLoadPayInvoice, PopulateApiParameter, SendDataToApi, CompleteLoadPayInvoice];

const adiPayInvoiceHandler = createHandlerChainRunner(chain,"ADIPayInvoiceHandler",);
export default adiPayInvoiceHandler;
